/* eslint-disable no-unused-vars */
import styled from "styled-components";
import { lighten, darken } from "polished";

const LightStyles = styled.div`
color: ${(props) => props.theme.dark_grey};

.header-wrapper {
  h1 {
    svg {
      color: ${(props) => props.theme.blue_g};
    }
  } 
  @media screen and (max-width: 767px) {
    .btn {
      &.btn-success,
      &.btn-purple,
      &.btn-warning,
      &.btn-info {
        &:not(#priorities-dropdown) {
          color: ${(props) => props.theme.blue_g};
          background: transparent !important;

          &:hover,
          &:focus {
            background: transparent !important;
          }
        }
      }
    }
  }
}

.content-wrapper {
  background: #fff;
  box-shadow: 0 3px 10px rgba(100, 104, 129, 0.04),
    0 3px 10px rgba(100, 104, 129, 0.01);
  h3 {
    color: ${(props) => props.theme.dark_grey};
  }
}

.bm-menu-wrap {
  ~ div {
    background: #fff;
  }
  .bm-menu {
    background: #fff !important;
    a {
      color: #b8b7ad;
      &:hover,
      &:focus {
        color: ${(props) => props.theme.primary};
      }
    }
  }
}

 /* Sidebar + Nav */
.navbar {
  background: #fff;
  .container {
    .navbar-header {
      .navbar-toggle {
        border: none;
        &:hover {
          background-color: ${(props) => props.theme.dark_grey};
        }
        &:focus {
          background-color: ${(props) => props.theme.primary};
        }
      }
      .navbar-dropdown {
        display: none;
      }
    }
    .navbar-nav {
      .dropdown {
        > a:first-child {
          .avatar-container {
            svg {
              color: #333 !important;
            }
          }
        }
        p {
          color: #222;
        }
      }
      .dropdown-menu {
        background: #fff !important;
        li {
          background: #fff !important;
          &:hover,
          &:focus {
            background: ${(props) => darken(0.05, "#fff")} !important;
          }
          &.active {
            &:before {
              border: 0 !important;
            }
          }
          a {
            border-bottom: 1px solid #eee;
            color: ${(props) => props.theme.dark_grey} !important;
          }
        }
      }
    }
  }
  .navbar-default {
    -webkit-box-shadow: 0 3px 10px rgba(100, 104, 129, 0.04),
      0 3px 10px rgba(100, 104, 129, 0.01);
    box-shadow: 0 3px 10px rgba(100, 104, 129, 0.04),
      0 3px 10px rgba(100, 104, 129, 0.01);
  }
  li {
    &.active {
      &:before {
        content: "";
        border-left: 4px solid ${(props) => props.theme.blue_g};
      }
      transition: 0.7s;
      a {
        color: ${(props) => props.theme.blue_g};
        background: transparent !important;
        svg {
          color: ${(props) => props.theme.blue_g} !important;
        }
        &:hover,
        &:focus {
          color: ${(props) => props.theme.blue_g} !important;
        }
      }
    }
    a {
      color: #333 !important;
      svg {
        color: ${(props) => props.theme.xdark_grey} !important;
      }
      &:hover,
      &:focus {
        color: ${(props) => lighten(0.25, props.theme.xdark_grey)} !important;
      }
    }
  }
  .sidebar {
    background: linear-gradient(
        rgba(255, 255, 255, 1),
        rgba(255, 255, 255, 0.9)
      ),
      url("/images/Backdrop-Transparent.png") no-repeat left bottom / 200%;
    .footer-tag {
      p {
        color: ${(props) => props.theme.dark_grey};
      }
    }
    .menu-header {
      a {
        color: ${(props) => props.theme.dark_grey} !important;
      }
    }
    .accordion {
      .accordion__title {
        color: ${(props) => props.theme.xdark_grey};
        svg {
          color: ${(props) => props.theme.xdark_grey} !important;
        }
      }
      .accordion__body {
        li {
          a {
            color: ${(props) => props.theme.xdark_grey} !important;
          }
          &.active {
            a {
              color: ${(props) => props.theme.blue_g} !important;
            }
          }
        }
      }
    }
  }
}

/* BREADCRUMBS */
.bread-aisle {
  h1 {
    color: ${(props) => props.theme.med_grey};
  }
  .loaf {
    .active {
      color: ${(props) => props.theme.dark_grey};
    }
  }

  @media screen and (max-width: 767px) {
    overflow: initial;
  }
}

.react-toggle {
  .react-toggle-track {
    background: ${(props) => props.theme.med_grey};
  }
  .react-toggle-thumb {
    border: 0;
  }
  &.react-toggle--checked {
    .react-toggle-track {
      background: ${(props) => props.theme.blue_g};
      svg {
        fill: #fff;
      }
    }
  }
  &:hover:not(.react-toggle--disabled) {
    .react-toggle-track {
      background: ${(props) => darken(0.1, "#4c6487")};
    }
  }
  &.react-toggle--focus .react-toggle-thumb {
    box-shadow: none !important;
  }
}

/* FORM */
.form {
  label {
    color: ${(props) => props.theme.med_grey};
  }
  .checkbox {
    label {
      color: ${(props) => props.theme.dark_grey} !important;
    }
  }
  .form-action {
    &:hover {
      cursor: pointer;
      color: ${(props) => props.theme.blue_g};
    }
  }
  .react-toggle {
    .react-toggle-track {
      background: ${(props) => darken(0.1, props.theme.light_grey)};
    }
    &.react-toggle--checked {
      .react-toggle-track {
        background: ${(props) => props.theme.dark_grey};
        svg {
          fill: #fff;
        }
      }
    }
    &:hover:not(.react-toggle--disabled) {
      .react-toggle-track {
        background: ${(props) => props.theme.dark_grey};
        .react-toggle-track-x,
        .react-toggle-track-check {
            color: black !important;
        }
      }
    }
  }
}
.react-toggle-track-x,
.react-toggle-track-check {
      margin-top: 5px;
      color: black;
     
}
.form-group, .report-filters {
  .form-control {
    background-color: #fff;
    color: ${(props) => props.theme.dark_grey} !important;
  }
  .form-control[disabled],
  .css-162g8z5 {
    background-color: ${(props) => darken(0.03, "#fafafa")};
  }
  input[type="date"] {
    border: 1px solid hsl(0, 0%, 80%);
    background-color: hsl(0, 0%, 100%);
    border-radius: 4px;
    padding: 0 10px;
  }
  /* Disabled Select */
  .css-1sontr1 {
    .css-162g8z5 {
      .css-142w6gm {
        color: ${(props) => props.theme.dark_grey} !important;
      }
    }
  }
  .react-datepicker-wrapper {
    width: 100%;
    .react-datepicker__input-container {
      width: 100%;
      .react-datepicker__close-icon {
        position: absolute;
        right: 0;
        &::after {
          background: none !important;
          color: #999;
          font-size: 16px;
          top: 40%;
          right: 0;
        }
      }
    }
  }
}
.DateRangePicker {
  width: 100%;
  .DateRangePickerInput {
    background-color: hsl(0, 0%, 100%);
    border: 1px solid hsl(0, 0%, 80%);
    input {
      color: #aaa;
      background-color: hsl(0, 0%, 100%);
    }
  }
}

/* BUTTONS */
.btn {
  &.btn-success {
    background: ${(props) => props.theme.green_g} !important;
    color: #fff;
    line-height: 18px;
    &:hover,
    &:focus {
      background: ${(props) => darken(0.05, props.theme.green_g)};
    }
  }
  &.btn-danger {
    background: ${(props) => props.theme.red_g} !important;
    color: white;
  }
  &.btn-purple {
    background: ${(props) => props.theme.purple_g};
    color: #fff;
    &:hover,
    &:focus {
      background: ${(props) => darken(0.05, props.theme.purple_g)} !important;
      color: #fff;
    };
  }
  &.btn-warning {
    background: ${(props) => props.theme.gold_g} !important;
    color: #fff;
    &.btn-edit {
    box-shadow: 0px 3px 0px ${(props) =>
      darken(0.1, props.theme.gold_g)} !important;
    }
    &:hover,
    &:focus {
      background: ${(props) => darken(0.05, props.theme.gold_g)};
    }
  }
  &.btn-cancel {
    background: ${(props) => props.theme.light_grey} !important;
    color: #555 !important;
    text-transform: uppercase;
    &:hover {
      background: ${(props) => darken(0.05, props.theme.light_grey)} !important;
    }
  }
  &.btn-default {
    &:not(.no-default) {
    color: ${(props) => props.theme.dark_grey} !important;
    }
  }
  &.btn-inline {
    &:disabled {
      box-shadow: 0px 2px 0px ${(props) => darken(0.1, props.theme.green_g)};
    }
  }
  &.btn-blue {
    background: ${(props) => props.theme.blue_g} !important;
    color: white;
    &:disabled {
      box-shadow: 0px 2px 0px ${(props) =>
        darken(0.1, props.theme.blue_g)} !important;
    }
  }
  &.btn-toggle {
    color: #ddd !important;
  }
}

.icon-btn {
  display: flex;
  justify-content: center;
  margin-left: auto;
  border-radius: 50%;
  color: #50accb;
  background: transparent;
  border: none;
  transition: all 0.3s ease-in-out;
}

.icon-btn:hover {
  transform: scale(1.1);
}

.icon-btn:disabled {
  cursor: not-allowed
}

/* PANEL & NOTES */
.panel {
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  .panel-heading {
    background: ${(props) => props.theme.blue_g};
    color: #fff;
  }
}

/* MODALS */
.modal-header {
  .close {
    svg {
      color: ${(props) => props.theme.dark_grey};
    }
  }
}

/* TABLES */
.ReactTable {
  a {
    color: ${(props) => props.theme.dark_grey} !important;
  }
  .rt-thead {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    .rt-resizable-header-content {
      color: ${(props) => props.theme.xmed_grey};
    }
  }

  .-pagination {
    .-next,
    .-previous {
      .-btn {
        background-color: ${(props) => props.theme.accent_green};
        color: #fff;
        &:hover,
        &:focus {
          background-color: ${(props) => darken(0.1, props.theme.accent_green)};
        }
      }
    }
  }
  .rt-expander {
    &:after {
      border-top: 7px solid ${(props) => props.theme.blue_g};
    }
  }
  .active {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    color: ${(props) => props.theme.green_g};
    * {
      color: ${(props) => props.theme.green_g};
    }
  }
  .inactive {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    color: ${(props) => props.theme.med_grey};
    * {
      color: ${(props) => props.theme.med_grey};
    }
  }
  .table-select {
    width: 100%;
    box-shadow: none;
    border: 0;
    background: transparent;
  }
  .review-summary {
    background: ${(props) => props.theme.light_grey};
  }
  .fa-star[data-prefix="far"] {
    color: ${(props) => props.theme.dark_grey} !important;
  }
  .fa-flag[data-prefix="far"] {
    color: ${(props) => props.theme.dark_grey} !important;
  }
  .table-select,
  .review-input {
    &.changed {
      background: ${(props) => darken(0.1, props.theme.light_grey)};
    }
  }
  .content-list,
  .review-input {
    &.changed {
      background: ${(props) => darken(0.1, props.theme.light_grey)};
    }
  }
}
.actions {
  .dropdown {
    button {
      border: 0 !important;
      box-shadow: none !important;
      svg {
        color: ${(props) => props.theme.dark_grey};
        font-size: 18px;
        margin-top: 5px;
      }
      &:hover,
      &:focus {
        border: 0 !important;
      }
      .caret {
        display: none;
      }
    }
  }
  .dropdown-menu {
    li {
      padding: 8px 15px !important;
      &:not(:last-child) {
        border-bottom: 1px solid #eee;
      }
      &:hover {
        background: ${(props) => props.theme.light_grey};
        transition: 0.3s;
        border: 0;
        * {
          outline: none !important;
        }
      }
    }
    a {
      display: flex;
      align-items: center;
      text-decoration: none !important;
      background: none;
      color: ${(props) => props.theme.dark_grey};
      padding: 0 !important;
      svg {
        margin-right: 10px;
      }
    }
  }
  button {
    margin: 0 !important;
    background: transparent !important;
    border: 1px solid ${(props) => props.theme.blue_g};
    color: ${(props) => props.theme.blue_g};
    padding: 8px 15px !important;
    &:focus,
    &:active {
      border: 1px solid ${(props) => props.theme.blue_g} !important;
      color: ${(props) => props.theme.blue_g} !important;
    }
  }
}

/* DROPDOWN MENU */
.dropdown-on-header {
  #priorities-dropdown{
    padding: 7px 15px !important;
    height: 31px;
    font-weight: 800;
    margin-bottom: 5px;
    font-size: 12px;
  }
  .dropdown-menu {
    li {
      padding: 8px 15px !important;
      &:not(:last-child) {
        border-bottom: 1px solid #eee;
      }
      &:hover {
        background: ${(props) => props.theme.light_grey};
        transition: 0.3s;
        border: 0;
        * {
          outline: none !important;
        }
      }
    }
    li.active {
      background: ${(props) => props.theme.light_grey};
    }
    a {
      display: flex;
      align-items: center;
      text-decoration: none !important;
      background: none;
      color: ${(props) => props.theme.dark_grey};
      padding: 0 !important;
      svg {
        margin-right: 10px;
      }
    }
  }
}

.ReactTable.-highlight {
  .rt-tbody {
    .rt-tr {
      &:not(.-padRow) {
        &:hover {
          background: ${(props) => props.theme.light_grey};
        }
      }
    }
  }
}

.ReactTable.-striped {
  .rt-tr.-odd {
    background: ${(props) => props.theme.light_grey};
  }
  .rt-tr.-padRow {
    background-color: #fff;
  }
  .rt-tr-group {
    min-height: 50px;
    .rt-tr.-odd {
      background: ${(props) => props.theme.xlight_grey};
    }
  }
  .rt-tbody {
    .rt-tr-group {
      border: 0px;
    }
  }
}

.ReactTable .-loading {
  background: #fff !important;
  div {
    top: 45% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
  }
}

/* USER PROFILE PAGE */
.profile.avatar {
  &:hover {
    span {
      color: ${(props) => props.theme.dark_grey};
      visibility: visible;
    }
  }
}

/* TIMESHEET */
.time-sheet {
}
.time-header {
  .label {
    color: ${(props) => props.theme.dark_grey};
    background: transparent;
  }
}
.time-row, .time-row-ticket {
  border-bottom: 1px solid ${(props) => props.theme.light_grey};
}
.time-row-ticket {
  background: ${(props) => props.theme.light_grey}
  border-radius: 5px;
}

.red-text {
  color: red;
  font-size: 12px;
  margin-left: 1rem;
}

.CircularProgressbar {
  .CircularProgressbar-trail {
    stroke: #eee;
  }
  .CircularProgressbar-path {
    stroke-linecap: square !important;
  }
  .CircularProgressbar-text {
    dominant-baseline: central !important;
    fill: ${(props) => props.theme.dark_grey} !important;
  }
  &.progressbar-success {
    .CircularProgressbar-path {
      stroke: ${(props) => props.theme.green_g};
    }
  }
  &.progressbar-warning {
    .CircularProgressbar-path {
      stroke: ${(props) => props.theme.gold_g};
    }
  }
  &.progressbar-danger {
    .CircularProgressbar-path {
      stroke: ${(props) => props.theme.red_g};
    }
  }
}

/* INVOICE */
.invoice-preview {
  padding: 0 10px;
  table {
    width: 100%;
    font-size: 13px;
    table-layout: fixed;
    .header {
      font-size: 13px;
      padding: 5px !important;
      margin-bottom: 20px;
      td {
        border-bottom: 0px;
        text-align: left !important;
        padding: 0px;
        white-space: nowrap;
        p {
          /* min-width: 180px; */
        }
        &:not(:first-child) {
          text-align: right !important;
        }
      }
    }
    th {
      border: none;
    }
    tr {
      height: 40px;
    }
    th,
    td {
      min-width: 100px;
      padding: 10px 5px;
      border: none;
      border-bottom: 1px solid ${(props) => props.theme.light_grey};
      text-align: right;
    }
    .total {
      font-weight: 700;
      td {
        border-top: 1px solid ${(props) => props.theme.med_grey} !important;
        border-bottom: none !important;
      }
    }
    .procedure-name {
      height: auto;
      td {
        padding: 10px 5px 0px 5px;
        border: 0 !important;
      }
      p {
        margin: 0;
        font-weight: 700;
        text-decoration: underline;
      }
    }
  }
}

/* CALENDAR */
.rbc-calendar {
  .rbc-today {
    background-color: #fff;
    border: 1px solid #333;
    border-left: 1px solid #333 !important;
  }
  .rbc-off-range-bg {
    background-color: #fafafa !important;
  }
  .toolbar-container {
    .views {
      button {
        font-family: "Nunito";
        border-radius: 0 !important;
        margin: 0 !important;
        padding: 15px;
        outline: none;
        /* border: 0 !important; background: ${(props) => props.theme.blue_g}; */
        &.active {
          background: ${(props) => props.theme.blue_g} !important;
          /* color: #fff !important; box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0); */
          box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1) !important;
        }
        &:focus,
        &:active {
          background: ${(props) => props.theme.blue_g} !important;
          color: #fff;
          box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1) !important;
        }
        &:first-child {
          border-top-left-radius: 3px;
          border-bottom-left-radius: 3px;
        }
        &:last-child {
          border-top-right-radius: 3px;
          border-bottom-right-radius: 3px;
        }
      }
    }
    .calendar-view {
      border: 0 !important;
      box-shadow: 0 !important;
    }
    display: block;
    font-size: 25px;
    text-transform: uppercase;
    text-align: center;
    div {
      &:before {
        display: none;
      }
      svg {
        /* display: none; */
      }
      &[role="button"] {
        padding: 10px 5px 0 5px;
        font-size: 30px;
      }
    }
    .legend-item {
      margin-right: 5px;
      font-size: 12px;
      .legend-color {
        display: inline-block;
        height: 10px;
        width: 10px;
        margin: 0 8px;
      }
      .legend-text {
        display: inline-block;
        font-size: 13px !important;
        margin: 0 5px 0 0;
        text-transform: capitalize;
        font-family: "Nunito";
      }
    }
  }
  button {
    padding: 5px !important;
    font-size: 12px;
    border-radius: 3px;
    margin: 10px 5px;
    width: 33%;
    border: 0;
    svg {
      color: #000;
    }
    &:focus {
      outline: none;
    }
  }
}

.rbc-agenda-table {
  border: 0;
  tr {
    border-top: none;
    &.date-cell-label {
      background: ${(props) => props.theme.light_grey};
      padding: 5px 10px;
      font-weight: bold;
      font-size: 15px;
    }
    &.event-cell-row {
      border-bottom: 1px solid ${(props) => props.theme.light_grey};
      display: flex;
    }
  }
  th,
  td {
    padding: 10px;
    &.rbc-agenda-time-cell {
      max-width: 100px;
      display: flex;
      align-items: center;
      text-align: center;
      span {
        white-space: normal !important;
      }
    }
    &.rbc-agenda-event-cell {
      border-left: 0;
      a {
        display: block;
        p {
          font-family: "Nunito" !important;
        }
        h4 {
          font-weight: 700;
        }
        &:hover,
        &:focus {
          text-decoration: none !important;
        }
      }
    }
  }
}

.DayPicker {
  margin: 0 auto;
}

/* WYSIWYG Styling */
.rdw-link-modal {
  height: 235px;
}

.rdw-link-decorator-icon {
  display: none;
}

@media (min-width: 768px) {
  /* .navbar { */
    /* max-height: 50px; */
  /* } */

  // ::-webkit-scrollbar {
  //   width: 0px !important;
  //   background: transparent !important;
  // }
  #page-wrapper {
    position: inherit;
    padding: 0 30px;
    border-left: 1px solid #e7e7e7;
  }
  .sidebar {
    z-index: 2;
    position: absolute;
    /* width: 225px; margin-top: 50px; */
    margin-top: 130px;
    height: calc(100vh - 70px);
    overflow: auto;
  }
}

/* MOBILE */
@media screen and (max-width: 767px) {
  background: #fff !important;
  .content-wrapper {
    background: transparent !important;
    h1 {
      text-align: center;
    }
    .btn-sm.right {
      margin: 10px auto;
      width: 20%;
      text-align: center;
      float: none;
      display: block;
    }
  }
  .rbc-calendar {
    margin: 0px;
  }
  .navbar {
    .btn {
      &.btn-default {
        background: transparent !important;
      }
    }
  }
}
.avatar {
  background: #b8bac5;
}

/* CALL APPROVAL */
.cap-container {
  .content-wrapper.cap-wrapper {
    background: transparent;

    .row-wrapper {
      background: white;
    }
  }

  .content-list {
    .list-item {
      background: #F4F6F9;

      .list-item-wrapper {
        background: white;
      }

      .notes {
        .row {
          background: #F7F7F7;

          .col-xs-4 {
            background: #F7F7F7;
          }
        }
      }
    }
  }

  .tasks-service-container {
    .row {
      .review-input {
        background: #F4F6F9;
      }

      .table-select {
        background: #F4F6F9;
      }
    }
  }
}

/* Surface */
.surface-primary {
  background: #FFF
}

.surface-secondary {
  background: #F4F6F9
}

/* Dashboard Calendar */
.dashboard-calendar-container {
  .arrow {
    color: ${(props) => props.theme.xmed_grey}
  }

  .slots-container {
    .slots-wrapper {
      .calendar-slot-container {
        &.is-weekend {
          .calendar-slot-wrapper {
            background: ${(props) => props.theme.xlight_grey} !important;
          }
        }

        .calendar-slot-wrapper {
          background: #fff !important;

          color: ${(props) => props.theme.xmed_grey}

          .day {
            color: ${(props) => props.theme.blue_g}  
          }
        }
        h2 {
          color: ${(props) => props.theme.blue_g}
        }
      }
    }
  }
}

/* Grid layout */
.toolbox {
  background: #fff

  .arrow.down {
    color: #262626
  }

  .toolbox__items {
    .toolbox__items__item {
      color: ${(props) => props.theme.xdark_grey}
    }
  }
}

.hide-button {
  background: #fff;
  color: ${(props) => props.theme.xdark_grey};
}

/* Dashboard */
.dashboard {
  .header-actions-fixed {
    &.scrolled {
      background-color: #F4F6F9;
    }
  }
}
      
/* IT Managed Report */
.plan-details-container {
  .pd-subtitle {
    color: #b2b2b2;
  }
  .pd-top {
    .pd-top-right {
      .tier-box {
        box-shadow: 0 3px 10px rgba(100, 104, 129, 0.04),
          0 3px 10px rgba(100, 104, 129, 0.01);
        background-color: ${(props) => props.theme.blue_g};
        color: #fff;
      }
    }
  }
  .pd-bottom {
    .sla-type {
      color: ${(props) => props.theme.blue_g}
    }
    
  }
}
.metric-box {
      box-shadow: 0 3px 10px rgba(100, 104, 129, 0.04),
        0 3px 10px rgba(100, 104, 129, 0.01);
    }
    .resolve-time {
      background-color: ${(props) => props.theme.green_g};
      color: #fff;
    }
    .assign-time {
      background-color: ${(props) => props.theme.blue_g};
      color: #fff;
    }
    .maintenance-alerts {
      background-color: ${(props) => props.theme.gold_g};
      color: #fff;
    }
    .total-tickets {
      background-color: ${(props) => props.theme.red_g};
      color: #fff;
    }
  }
}

.ticket-details-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-top: 2rem;
  text-align: center;

  .ticket-grid-col {
    display: grid;
    justifyItems: center;
    alignContent: center;
    grid-template-columns: repeat(4, 1fr);
  }

  .leyend {
    font-size: 1.5rem;
    text-transform: uppercase;
  }
  .amount {
    color: ${(props) => props.theme.blue_g};
    font-size: 3.25rem;
  }
}

/* Department Project Summary Report */
.project-summary-container {
  .ps-note-wrapper {
    background-color: #f4f6f9;
  }
}

/* Employee Summary By Project Report */
.project-employee-summary-container {
  .toggle-wrapper {
    span {
      &.not-selected {
        color: rgba(0, 0, 0, 0.4);
      }
    }
  }
}
`;

export default LightStyles;
